import React, { useState } from 'react';
import { Modal, Box, IconButton, Typography, Button, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CreateGroupForm from './createGroupForm';
import { GroupFormState, GroupOption } from '.';
import { useCreateAccountGroupMasterMutation } from '../../api/groupMaster.api';
import { CreateAccountGroupMasterInput } from '../../../../graphql';
import { showErrorSnackbar, showSuccessSnackbar } from '../../../../components/snackBar/snakbar';
import Loader from '../../../../pages/PrimeFigma/Components/Loader';

interface GroupModalProps {
  open: boolean;
  onClose: () => void;
  onSave?: (payload: GroupOption) => void;
  parentGroupOptions: [];
}

const initialFormState: GroupFormState = {
  groupName: '',
  groupType: { label: '', value: 0,accountTypeCD:'', },
  errorStatus: {
    groupName: false,
    groupType: false,
  },
  errorFields: {
    groupName: '',
    groupType: '',
  },
};

const GroupModal: React.FC<GroupModalProps> = ({ open, onClose, parentGroupOptions,onSave }) => {
  const [formState, setFormState] = useState<GroupFormState>(initialFormState);
  const [createAccountGroupMaster, { isLoading: creating }] = useCreateAccountGroupMasterMutation();
  const handleClose = () => {
    setFormState(initialFormState);
    onClose();
  };
  const formValidation = (data: GroupFormState): boolean => {
    let isValid = true;
    let obj = { ...data };
    Object.keys(data).map((key) => {
      if (key === 'groupName') {
        if (data[key].trim().length <= 0) {
          isValid = false;
          obj.errorFields.groupName = 'Group Name is required';
          obj.errorStatus.groupName = true;
        } else {
          obj.errorFields.groupName = '';
          obj.errorStatus.groupName = false;
        }
      }
      if (key === 'groupType') {
        if (data[key]?.label === '') {
          isValid = false;
          obj.errorFields.groupType = 'Group Type is required';
          obj.errorStatus.groupType = true;
        } else {
          obj.errorFields.groupType = '';
          obj.errorStatus.groupType = false;
        }
      }
    });
    setFormState(obj);
    return isValid;
  };

   const saveGroups = async() => {
  const normalized = {
    ...formState,
    groupName: formState.groupName.trim(),
  };
  
  if (formValidation(normalized)) { 
   const   payLoad:CreateAccountGroupMasterInput = {
          accountgroupname:normalized?.groupName,
          accountparentgroupid: Number(normalized?.groupType?.value),
          accounttypecd: String(normalized?.groupType?.accountTypeCD),
        };
          const resPonse = await createAccountGroupMaster({
        createAccountGroupMasterInput: payLoad,
      }).unwrap();
      if(resPonse?.createAccountGroupMaster?.statuscode==='SUCCESS'){
        showSuccessSnackbar(resPonse?.createAccountGroupMaster?.statusmessage??'');
        const newValue:GroupOption={
          label:resPonse?.createAccountGroupMaster?.accountgroupname??'',
          value:resPonse?.createAccountGroupMaster?.accountgroupid??0,
          accountTypeCD:resPonse?.createAccountGroupMaster?.accounttypecd??'',
        };
        onSave?.(newValue);
        handleClose();
      }else{
        showErrorSnackbar(resPonse?.createAccountGroupMaster?.statusmessage??'Some thing went wrong');
      }
      
  }
};
    
  return (
    <Modal open={open} onClose={handleClose} sx={{zIndex:5501}}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          width: {xs:'90%', md:560},
          outline: 'none',
        }}
      >
        <Box
          sx={{
            bgcolor: '#8D167A',
            color: 'white',
            px: 2.5,
            py: 1.75,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Add Group
          </Typography>
          <IconButton aria-label="close" onClick={handleClose} sx={{ color: 'white' }} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ p: 2.5 }}>
          <CreateGroupForm formState={formState} setFormState={setFormState} parentGroupOptions={parentGroupOptions} />
        </Box>

        <Divider />
        <Box
          sx={{
            p: 2.5,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              borderColor: '#8D167A',
              color: '#8D167A',
              '&:hover': { borderColor: '#8D167A' },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={saveGroups}
            variant="contained"
            disableElevation
            sx={{
              bgcolor: '#8D167A',
              '&:hover': { bgcolor: '#7b136a' },
              minWidth: 88,
            }}
          >
            Save
          </Button>
        </Box>
         <Loader open={creating}/>
      </Box>
     
    </Modal>
  );
};

export default GroupModal;
